import React, { useEffect } from "react";
import { Link } from "gatsby";
import { navigate } from "@reach/router";
import Header from "../components/header";
import Footer from "../components/footer";

const LayoutIndex = props => {
  const handleKeys = (event) => {
    if (event.key !== 'ArrowRight') {
      return;
    }

    navigate('/slides/0');
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeys);

    return () => {
      window.removeEventListener('keydown', handleKeys);
    };
  });
  
  return (
    <div className="layout-body layout-body-3">
      <div className="container">      
        <div className="row bottom-xs layout-content">
          <div className="col-xs-12 col-sm-8 col-lg-6 text index-page">
            <h1>{props.title}</h1>
            <p className="lead">{props.paragraph1}</p>
            <p className="lead">{props.paragraph2}</p>
            <Link to="/slides/0" id="btn-next" className="btn btn-orange">Start</Link>
          </div>
          <div className="col-xs-12 col-sm-4 col-lg-4 image">
            <img alt="" src={props.image} />
          </div>
        </div>
      </div>
      <Header />
      <Footer />
    </div>
  );
};

export default LayoutIndex;
